import * as React from 'react';
import createSvgIcon from '../utils/createSvgIcon';

const WindowEditIcon = createSvgIcon({
  svg: ({ classes }) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2048 2048" className={classes.svg} focusable="false">
      <path d="M2048 128v640h-128V640H128v1024h640v128H0V128h2048zm-128 128H128v256h1792V256zm-72 640q42 0 78 15t64 42 42 63 16 78q0 39-15 76t-43 65l-717 719-377 94 94-377 717-718q28-28 65-42t76-15zm51 249q21-21 21-51 0-31-20-50t-52-20q-14 0-27 4t-23 15l-692 694-34 135 135-34 692-693z" />
    </svg>
  ),
  displayName: 'WindowEditIcon',
});

export default WindowEditIcon;
